module.exports = __webpack_public_path__ + "d697107f03dfa28510317c599de56ebb.png";